module.exports = __webpack_public_path__ + "static/media/SohoGothicProMedium.6dc05089.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SohoGothicProMedium.woff
// module id = 834
// module chunks = 0